import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/LiveQA.css';

const LiveQA = () => {
  return (
    <>
      <Helmet>
        <title>Live Q&A - Interactive Business Discussions | Redbox Global</title>
        <meta name="description" content="Join Redbox Global Live Q&A sessions with industry experts, CEOs, and analysts. Ask questions, get real-time answers, and engage with business leaders on pressing topics." />
        <meta name="keywords" content="live Q&A, business discussions, expert interviews, interactive sessions, ask experts, live chat, business questions, CEO Q&A, analyst sessions" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/live-qa" />
        <meta property="og:title" content="Live Q&A - Interactive Business Discussions | Redbox Global" />
        <meta property="og:description" content="Join interactive Q&A sessions with industry experts, CEOs, and analysts. Get real-time answers to your business questions." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1560439514-4e9645039924?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/live-qa" />
        <meta name="twitter:title" content="Live Q&A - Interactive Business Discussions | Redbox Global" />
        <meta name="twitter:description" content="Join interactive Q&A sessions with industry experts, CEOs, and analysts. Get real-time answers to your business questions." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1560439514-4e9645039924?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/live-qa" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Live Q&A</h1>
          <p className="page-subtitle">Interactive sessions with industry leaders, experts, and analysts</p>
        </div>
        
        <div className="page-content">
          <a href="/article/market-outlook-qa" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1560439514-4e9645039924?w=1200&h=600&fit=crop" alt="Live Q&A session" />
              </div>
              <div className="featured-content">
                
                <h2>2026 Market Outlook: Ask the Experts</h2>
                <p>Join our chief market strategist and top economists for an in-depth discussion on 2026 market trends, investment opportunities, and economic forecasts. Submit your questions in advance or ask live during the session. Interactive chat, polls, and expert insights.</p>
                <span className="article-meta">February 12, 2026 • 2:00 PM ET • 60 Minutes</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/ceo-roundtable-qa" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=600&h=400&fit=crop" alt="CEO roundtable" />
                </div>
                <div className="article-content">
               
                  <h2>CEO Roundtable: Future of Work</h2>
                  <p>Three Fortune 500 CEOs discuss remote work, AI integration, and building resilient organizations.</p>
                  <span className="article-meta">February 20, 2026 • 3:00 PM ET</span>
                </div>
              </article>
            </a>

            <a href="/article/crypto-blockchain-qa" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&h=400&fit=crop" alt="Crypto discussion" />
                </div>
                <div className="article-content">
                 
                  <h2>Crypto & Blockchain Deep Dive</h2>
                  <p>Leading crypto analysts answer your questions on digital assets, DeFi, and regulation.</p>
                  <span className="article-meta">February 28, 2026 • 1:00 PM ET</span>
                </div>
              </article>
            </a>

            <a href="/article/investor-strategies-qa" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop" alt="Investment strategies" />
                </div>
                <div className="article-content">
                 
                  <h2>Smart Investing Strategies Q&A</h2>
                  <p>Portfolio managers share insights on diversification, risk management, and growth opportunities.</p>
                  <span className="article-meta">March 5, 2026 • 4:00 PM ET</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LiveQA;
